/* Newsletter → Klaviyo + Shopify.
   - Formularios con [data-nl-success] (footer y home): envío AJAX → suscribe a
     Klaviyo, registra el alta en Shopify en segundo plano y muestra el mensaje
     de éxito EN SU SITIO sin recargar. Además marca el estado en la URL
     (?newsletter_subscribed=1) para que, si la página se recarga, el éxito
     PERSISTA y no vuelva a aparecer el campo de email.
   - Resto de formularios "newsletter" (landing): envío nativo + Klaviyo con
     keepalive. */
(function () {
  var KEY = window.__KLAVIYO_PUBLIC_KEY__;
  var LIST = window.__KLAVIYO_LIST_ID__;
  var ENDPOINT = KEY ? 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KEY) : '';
  var URL_FLAG = 'newsletter_subscribed';

  function subscribeKlaviyo(email, source) {
    if (!KEY || !LIST || !email) return;
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source || 'Newsletter',
              profile: { data: { type: 'profile', attributes: { email: email } } },
            },
            relationships: { list: { data: { type: 'list', id: LIST } } },
          },
        }),
      }).catch(function () {});
    } catch (e) {
      /* nunca bloquea */
    }
  }

  // Expuesta globalmente para que otros módulos (p. ej. el consentimiento
  // comercial del carrito) puedan suscribir un email a Klaviyo con la misma lógica.
  window.destiloKlaviyoSubscribe = subscribeKlaviyo;

  // Registra el alta en Shopify en segundo plano (mismo POST que el form nativo).
  function submitShopify(form) {
    try {
      fetch(form.action || window.location.pathname, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
      }).catch(function () {});
    } catch (e) {
      /* noop */
    }
  }

  // Sustituye el formulario por su mensaje de éxito (en su sitio).
  function showSuccess(form) {
    var successEl = form.querySelector('[data-nl-success]');
    if (!successEl || form.dataset.nlDone === '1') return;
    var msg = successEl.cloneNode(true);
    msg.removeAttribute('data-nl-success');
    msg.hidden = false;
    form.innerHTML = '';
    form.appendChild(msg);
    form.dataset.nlDone = '1';
  }

  // Deja constancia en la URL sin recargar.
  function markUrl() {
    try {
      var u = new URL(window.location.href);
      if (!u.searchParams.has(URL_FLAG)) {
        u.searchParams.set(URL_FLAG, '1');
        window.history.replaceState(null, '', u.toString());
      }
    } catch (e) {
      /* noop */
    }
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.nodeName !== 'FORM') return;
      var tags = form.querySelector('input[name="contact[tags]"]');
      if (!tags || tags.value.indexOf('newsletter') === -1) return;

      var emailInput = form.querySelector('input[type="email"], input[name="contact[email]"]');
      var email = emailInput && emailInput.value ? emailInput.value.trim() : '';
      if (!email) return;

      var source = 'Web · ' + (document.title || 'Destilo');

      if (form.querySelector('[data-nl-success]')) {
        // AJAX en su sitio, sin recargar (footer + home).
        e.preventDefault();
        e.stopPropagation();
        markUrl();
        subscribeKlaviyo(email, source);
        submitShopify(form);
        showSuccess(form);
      } else {
        // Nativo (landing): Klaviyo con keepalive y el form recarga.
        subscribeKlaviyo(email, source);
      }
    },
    true
  );

  // Al cargar: si la URL marca suscripción, muestra el éxito (persistencia).
  function onReady() {
    try {
      if (new URL(window.location.href).searchParams.has(URL_FLAG)) {
        document.querySelectorAll('form [data-nl-success]').forEach(function (el) {
          var form = el.closest('form');
          if (form) showSuccess(form);
        });
      }
    } catch (e) {
      /* noop */
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
